import * as React from "react";
import type { SVGProps } from "react";
const SvgShare1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 11.459 11.4 5.1v3.6C3 10.5 3 18.9 3 18.9s3.6-4.8 8.4-4.2v3.72z"
    />
  </svg>
);
export default SvgShare1;
